module.exports = __webpack_public_path__ + "media/emails/send-receipt-d402e9ba.png";